import React, { useRef } from 'react';
import { formatDollars, FREQUENCY_LABELS } from '../../shared/givingHelpers';
import SimulateWebhookButton from './SimulateWebhookButton';
import DonationPaymentStep from '../../../shared/DonationPaymentStep';
import TurnstileChallenge from '../../../shared/TurnstileChallenge';
import TurnstileDisclosure from '../../../shared/TurnstileDisclosure';
import useDonationFormState from './useDonationFormState';
import DonationFormBody from './DonationFormBody';

const PublicDonationForm = ({
  campaignName,
  primaryColor,
  presetAmounts,
  enabledFrequencies,
  buttonText,
  dedicationEnabled,
  dedicationOptions,
  presetAmountDescriptions,
  showOtherAmount = true,
  donationsCreateUrl,
  recurringDonationsCreateUrl,
  feeRules,
  stripePublishableKey,
  stripeConnectedAccountId,
  turnstileSiteKey,
  canDonate,
  nonProduction,
  giftQuestions,
}) => {
  const turnstileRef = useRef(null);
  const formState = useDonationFormState({
    presetAmounts,
    presetAmountDescriptions,
    enabledFrequencies,
    dedicationOptions,
    donationsCreateUrl,
    recurringDonationsCreateUrl,
    feeRules,
    turnstileRef,
    giftQuestions,
  });
  const { activeAmount, phase, clientSecret, submitDonation, onPaymentSuccess, reset } = formState;
  const showDedication = dedicationEnabled === true;
  const style = { '--gc-primary': primaryColor || '#1982C4' };

  if (canDonate === false) {
    return (
      <div className="gc-content-card gc-donation-form" style={style}>
        <p className="gc-donation-unavailable">
          This campaign isn’t accepting online donations yet. Please check back soon.
        </p>
      </div>
    );
  }

  if (phase === 'thankYou') {
    return (
      <div className="gc-content-card gc-thankyou-card" style={style}>
        <div className="gc-thankyou-icon">&#10003;</div>
        <h2 className="gc-thankyou-title">Thank you!</h2>
        <p className="gc-thankyou-message">
          Your generous {formatDollars(activeAmount)} gift to {campaignName} makes a difference.
        </p>
        <button className="gc-thankyou-close" onClick={reset}>
          Make Another Gift
        </button>
        {nonProduction && clientSecret && <SimulateWebhookButton clientSecret={clientSecret} />}
      </div>
    );
  }

  return (
    <div className="gc-content-card gc-donation-form" style={style}>
      {phase === 'payment' ? (
        <>
          <div className="gc-form-section-title">Payment details</div>
          <DonationPaymentStep
            stripePublishableKey={stripePublishableKey}
            stripeConnectedAccountId={stripeConnectedAccountId}
            clientSecret={clientSecret}
            onSuccess={onPaymentSuccess}
            buttonClassName="gc-give-btn"
          />
        </>
      ) : (
        <>
          <div className="gc-form-section-title">Choose amount</div>
          <TurnstileChallenge ref={turnstileRef} sitekey={turnstileSiteKey} />
          <DonationFormBody
            formState={formState}
            buttonText={buttonText}
            showDedication={showDedication}
            showOtherAmount={showOtherAmount}
            frequencyLabels={FREQUENCY_LABELS}
            onGive={submitDonation}
          />
          <TurnstileDisclosure />
        </>
      )}
    </div>
  );
};

export default PublicDonationForm;
